/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import {
    func, bool, string, object,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import { useLazyQuery } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import GraphqlPDPCalendar from '../../Partials/GraphqlPDPCalendar/GraphqlPDPCalendar';
import memberDucks from '../../../../../../state/ducks/Member/ducks';
import {
    getBrand,
} from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getIsAuthenticatedStatus } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

import findCalendar from '../../../../../gql/queries/findCalendar';
import { GRAPHQL_ENV } from '../../../../../gql';

import {
    getLocationType,
    getValidatedZipcode,
    getIsProductFilterZipcodeValid,
    getUserSubmittedProductFilterZipcode,
    getSavedAddress,
    getWineData,
    getCountryData,
    getDataDictionary,
} from '../../../../../../state/ducks/App/App-Selectors';

const {
    common: {
        commonSelectors: {
            getAccessToken,
            getUserType,
        },
    },
} = memberDucks;

const ProductPlantsCalendar = ({
    /* eslint-disable react/jsx-props-no-spreading */
    productSkus, countryData, product, selectedSku, hasWine, isPassportBundleProduct, brand, userRole,
    fireCalendarQuery, setFireCalendarQuery, setCalendarIsLoading, setDeliveryDate, validatedZip, deliveryDate,
}) => {
    let userType;
    if (userRole === 'P') {
        userType = 'passport';
    } else {
        userType = 'guest';
    }

    const [todayTomDateNotAvailText, setTodayTomDateNotAvailText] = useState('');
    const [deliveryAvailable, setDeliveryAvailable] = useState(true);
    const productDeliveryType = product && product.availability && product.availability.productDeliveryType ? product.availability.productDeliveryType : '';
    const FIND_CALENDAR_QUERY = findCalendar();
    const [getCalendar, {
        error, data,
    }] = useLazyQuery(FIND_CALENDAR_QUERY);
    const closeCalendar = () => {
        setFireCalendarQuery(false);
        setCalendarIsLoading(false);
        setTodayTomDateNotAvailText('');
    };
    const setCalendarDataLoadingFlag = (boolean) => {
        setCalendarIsLoading(boolean);
    };
    const handleDeliveryAvailability = (boolean) => {
        setDeliveryAvailable(boolean);
    };
    const isInternationalProduct = () => {
        if (typeof productSkus?.[0]?.isInternational !== 'undefined') return productSkus[0].isInternational || false;
        return false;
    };
    const getInternationalCountry = () => {
        let countryCode = '';
        const country = window?.location?.pathname.split('/')[2] || '';
        for (let i = 0; i < countryData.length; i += 1) {
            if (countryData[i]?.iso_code_2 === country.toUpperCase()) {
                countryCode = countryData[i]?.iso_code_3?.split(' ')[0];
            }
        }
        return countryCode;
    };
    const ageDetails = {
        birthDay: '0',
        birthMonth: '0',
        birthYear: '0',
        minAge: '0',
    };
    const personalization = { modalOpen: false };
    const calendarModalProps = {
        isOpen: fireCalendarQuery,
        classes: {},
        cmsData: data?.findCalendar?.content,
        close: closeCalendar,
        selectedItemId: selectedSku?.id,
        setCalendarDataLoadingFlag,
        handleDeliveryAvailability,
        orderItemId: '',
        deliveryType: productDeliveryType,
        brandId: product.brandId,
        ageDetails,
        partNumber: product.partNumber,
        todayTomDateNotAvailText,
        sympathyValue: product.sympathyValue,
        pageType: '',
        zipCode: validatedZip,
        breadCrumbArray: [],
        productName: product?.name,
        isInternationalProduct: isInternationalProduct(),
        internationalCountry: getInternationalCountry(),
        isPassportBundleItem: false,
        personalization,
        movieSelected: {},
        isPassportBundleProduct: isPassportBundleProduct || {},
        selectedSku,
        hasWine,
        setDeliveryDate,
        deliveryAvailable,
        deliveryDate,
    };
    useEffect(() => {
        getCalendar({
            variables: {
                brand: brand['domain-name'],
                environment: GRAPHQL_ENV,
                productType: productDeliveryType,
                userType,
            },
        });
    }, []);
    if (error) {
        mbpLogger.logError({
            query: FIND_CALENDAR_QUERY,
            component: 'GraphqlCalendarContainer.js',
            message: 'Error loading calendar',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }
    return <GraphqlPDPCalendar {...calendarModalProps} />;
};

const mapStateToProps = (state) => ({
    locationType: getLocationType(state),
    jwt: getAccessToken(state),
    brand: getBrand(state),
    validatedZip: getValidatedZipcode(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    savedAddress: getSavedAddress(state),
    userRole: getUserType(state),
    wineValidation: getWineData(state),
    countryData: getCountryData(state),
    dataDictionary: getDataDictionary(state),
});

ProductPlantsCalendar.propTypes = {
    productSkus: string.isRequired,
    countryData: string.isRequired,
    product: object.isRequired,
    selectedSku: string.isRequired,
    hasWine: bool.isRequired,
    isPassportBundleProduct: bool.isRequired,
    brand: object.isRequired,
    userRole: string.isRequired,
    fireCalendarQuery: bool.isRequired,
    setFireCalendarQuery: func.isRequired,
    setCalendarIsLoading: func.isRequired,
    setDeliveryDate: func.isRequired,
    validatedZip: string.isRequired,
    deliveryDate: object.isRequired,
};

export default withRouter(
    connect(
        mapStateToProps,
        null,
    )(ProductPlantsCalendar),
);
